/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * Frontend JS.
 */
var $ = require("jquery");
var Flickity = require('flickity');

const flkty = new Flickity('.block-image-content-slider .slider', {
    pageDots: true,
    prevNextButtons: true,
    groupCells: 1,
    cellAlign: 'left',
    contain: true
});